<script lang="ts">
    let { line1, line2, line3 } = $props()
    let imgHeight: number = $state(0)

    const engravingPreviewAlt = $derived.by(() => {
        const lines = [line1, line2, line3].filter((line) => typeof line === "string" && line.trim().length > 0)
        return lines.length > 0 ? `Vorschau Gravur: ${lines.join(" / ")}` : "Vorschau Gravurplatte"
    })
</script>

<div class="engraving_preview" bind:clientHeight={imgHeight}>
    <img src="/media/edelstahl.jpg" alt={engravingPreviewAlt} />
    <div class="line line1" style="font-size: {imgHeight / 4}px">
        {line1 || ""}
    </div>
    <div class="line line2" style="font-size: {imgHeight / 4}px">
        {line2 || ""}
    </div>
    <div class="line line3" style="font-size: {imgHeight / 1.4}px">
        {line3 || ""}
    </div>
</div>

<style lang="less">
    .engraving_preview {
        position: relative;

        img {
            width: 100%;
            border: 1px solid var(--secondary);
            border-radius: var(--mainborder-radius);
        }

        .line {
            font-family: "Engraving";
            position: absolute;
            line-height: 100%;
        }

        .line1 {
            top: 20%;
            left: 6%;
        }
        .line2 {
            bottom: 25%;
            left: 6%;
        }
        .line3 {
            top: 15%;
            right: 10%;
        }
    }
</style>
